{
  "help": "Довідка",
  "info": "Інформація"
}
